document.addEventListener('DOMContentLoaded', () => {
    const datiFatturazioneModal = document.getElementById('DatiFatturazioneModal');
    document.body.addEventListener('click', e => {
        let el = e.target;
        while (el) {
            if (el.name === "checkout" && el.type === "submit") {
                e.preventDefault();
                e.stopPropagation();

                fillFormFields();
                datiFatturazioneModal.classList.add('open');
                return false;
            }
            el = el.parentElement;
        }
    });
    datiFatturazioneModal.querySelectorAll('overlay-element, .drawer__close, #dati-fatturazione--button-annulla').forEach(el => {
        el.addEventListener('click', () => {
            datiFatturazioneModal.classList.remove('open');
        });
    });
    datiFatturazioneModal.querySelector('#dati-fatturazione--form-section').addEventListener('change', updateFormStatus);
    datiFatturazioneModal.querySelector('#dati-fatturazione--form-section').addEventListener('input', updateFormStatus);
    datiFatturazioneModal.querySelector('#dati-fatturazione--form').addEventListener('submit', e => {
        e.preventDefault();
        e.stopPropagation();

        const fieldsData = validateFields();
        if (fieldsData) {
            localStorage.setItem("dati-fatturazione", JSON.stringify(fieldsData));
            const formData = new FormData();
            for (const [key, val] of Object.entries(fieldsData)) {
                formData.append(`attributes[${key}]`, val);
            }
            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                body: formData,
            })
            .then(response => response.json())
            .then(data => {
                window.location.href = window.Shopify.routes.root + 'checkout';
            });
        }

        return false;
    });

    function fillFormFields() {
        try {
            const fieldsData = JSON.parse(localStorage.getItem("dati-fatturazione"));
            const radios = ["dove-risiedi", "tipo-fattura", "privato--genere", "privato--paese-nascita"];
            for (const [key, val] of Object.entries(fieldsData)) {
                if (radios.includes(key)) {
                    datiFatturazioneModal.querySelector(`[name="${key}"][value="${val}"]`).checked = true;
                } else {
                    datiFatturazioneModal.querySelector(`[name="${key}"]`).value = val;
                }
            }
        } catch (error) {}

        updateFormStatus();
    }

    function updateFormStatus() {
        const sectionFattura = datiFatturazioneModal.querySelector('#dati-fatturazione--fattura');
        const sectionPrivato = datiFatturazioneModal.querySelector('#dati-fatturazione--privato');
        const sectionAzienda = datiFatturazioneModal.querySelector('#dati-fatturazione--azienda');
        const sectionPrivatoLuogoNascita = datiFatturazioneModal.querySelector('#dati-fatturazione--privato--luogo-nascita');
        const sectionPrivatoNazioneNascita = datiFatturazioneModal.querySelector('#dati-fatturazione--privato--nazione-nascita');
        const fieldCodiceFiscale = datiFatturazioneModal.querySelector('[name="privato--codice-fiscale"]');

        const valRisiediItalia = datiFatturazioneModal.querySelector('[name="dove-risiedi"][value="italia"]').checked;
        const valRisiediEstero = datiFatturazioneModal.querySelector('[name="dove-risiedi"][value="estero"]').checked;
        const valTipoPrivato = datiFatturazioneModal.querySelector('[name="tipo-fattura"][value="privato"]').checked;
        const valTipoAzienda = datiFatturazioneModal.querySelector('[name="tipo-fattura"][value="azienda"]').checked;
        const valNascitaItalia = datiFatturazioneModal.querySelector('[name="privato--paese-nascita"][value="italia"]').checked;
        const valNascitaEstero = datiFatturazioneModal.querySelector('[name="privato--paese-nascita"][value="estero"]').checked;

        sectionFattura.classList.toggle('open', valRisiediItalia);
        sectionPrivato.classList.toggle('open', valTipoPrivato);
        sectionAzienda.classList.toggle('open', valTipoAzienda);
        sectionPrivatoLuogoNascita.classList.toggle('open', valNascitaItalia);
        sectionPrivatoNazioneNascita.classList.toggle('open', valNascitaEstero);

        if (document.activeElement.id !== "dati-fatturazione--privato--codice-fiscale--field") {
            if ((fieldCodiceFiscale.dataset.valueAuto || "") === fieldCodiceFiscale.value) {
                const codiceFiscale = calcolaPrivatoCodiceFiscale() || "";
                fieldCodiceFiscale.value = codiceFiscale;
                fieldCodiceFiscale.dataset.valueAuto = codiceFiscale;
            }
        }

        validateFields();
    }

    function calcolaPrivatoCodiceFiscale(omocodie = [], indiceCodiceLuogoNascita = -1) {
        const cognome = datiFatturazioneModal.querySelector('[name="privato--cognome"]').value.toUpperCase();
        if (!cognome) {
            return false;
        }

        const nome = datiFatturazioneModal.querySelector('[name="privato--nome"]').value.toUpperCase();
        if (!nome) {
            return false;
        }

        const dataNascita = datiFatturazioneModal.querySelector('[name="privato--data-nascita"]').value;
        if (!dataNascita) {
            return false;
        }

        const genere = datiFatturazioneModal.querySelector('[name="privato--genere"]:checked')?.value;
        if (!genere) {
            return false;
        }

        const paeseNascita = datiFatturazioneModal.querySelector('[name="privato--paese-nascita"]:checked')?.value;
        if (!paeseNascita) {
            return false;
        }

        const luogoNascita = datiFatturazioneModal.querySelector(`[name="privato--${paeseNascita === "italia" ? "luogo" : "nazione"}-nascita"]`).value.trim().toUpperCase();
        if (!luogoNascita) {
            return false;
        }
        
        const codiciLuoghiNascita = (paeseNascita === "italia") ? datiFatturazioneCodiciItalia : datiFatturazioneCodiciEstero;
        if (!codiciLuoghiNascita.hasOwnProperty(luogoNascita)) {
            return false;
        }

        const codiciLuogoNascita = codiciLuoghiNascita[luogoNascita].split("|");
        if (indiceCodiceLuogoNascita !== -1 && codiciLuogoNascita.length <= indiceCodiceLuogoNascita) {
            return false;
        }

        const codiceLuogoNascita = codiciLuoghiNascita[luogoNascita].split("|").at(indiceCodiceLuogoNascita);

        return calcolaCodiceFiscale(cognome, nome, dataNascita, genere, codiceLuogoNascita, omocodie);
    }

    function calcolaCodiceFiscale(cognome, nome, dataNascita, genere, codiceLuogoNascita, omocodie = []) {
        const mesi = ['A', 'B', 'C', 'D', 'E', 'H', 'L', 'M', 'P', 'R', 'S', 'T'];
        const vocali = ['A', 'E', 'I', 'O', 'U'];
        const consonanti = ['B', 'C', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'V', 'W', 'X', 'Y', 'Z'];
        const matriceOmocodie = {"0": "L", "1": "M", "2": "N", "3": "P", "4": "Q", "5": "R", "6": "S", "7": "T", "8": "U", "9": "V"};

        function calcolaCognome() {
            let res = '';
            let i = 0;
            while (res.length < 3 && (i + 1 <= cognome.length)) {
                if (consonanti.includes(cognome[i])) {
                    res += cognome[i];
                }
                i++;
            }

            // Se non bastano le consonanti, prendo le vocali
            i = 0;
            while (res.length < 3 && (i + 1 <= cognome.length)) {
                if (vocali.includes(cognome[i])) {
                    res += cognome[i];
                }
                i++;
            }

            res += "XXX";
            return res.substring(0, 3);
        }

        function calcolaNome() {
            let res = '';
            let i = 0;
            while (res.length < 4 && (i + 1 <= nome.length)) {
                if (consonanti.includes(nome[i])) {
                    res += nome[i];
                }
                i++;
            }

            if (res.length > 3) {
                return res[0] + res[2] + res[3];
            }

            // Se non bastano prendo le vocali
            i = 0;
            while (res.length < 3 && (i + 1 <= nome.length)) {
                if (vocali.includes(nome[i])) {
                    res += nome[i];
                }
                i++;
            }

            res += "XXX";
            return res.substring(0, 3);
        }

        function calcolaData() {
            let [anno, mese, giorno] = dataNascita.split("-");
            if (genere === "femmina") giorno = (parseInt(giorno) + 40).toString();
            return anno.substring(2, 4) + mesi[mese - 1] + giorno;
        }

        function calcolaOmocodia(codice) {
            for (const [omocodia, indice] of [6, 7, 9, 10, 12, 13, 14].entries()) {
                if (omocodie.at(omocodia)) {
                    codice = codice.substr(0, indice) + matriceOmocodie[codice[indice]] + codice.substr(indice + 1);
                }
            }
            return codice;
        }

        let codiceFiscale = calcolaOmocodia(calcolaCognome() + calcolaNome() + calcolaData() + codiceLuogoNascita);
        codiceFiscale += codiceControlloCodiceFiscale(codiceFiscale);

        return codiceFiscale;
    }

    function codiceControlloCodiceFiscale(codiceFiscale) {
        const alfabeto = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
        const caratteri = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].concat(alfabeto);
        const matriceCodiceControllo = {"01": 1, "00": 0, "11": 0, "10": 1, "21": 5, "20": 2, "31": 7, "30": 3, "41": 9, "40": 4, "51": 13, "50": 5, "61": 15, "60": 6, "71": 17, "70": 7, "81": 19, "80": 8, "91": 21, "90": 9, "101": 1, "100": 0, "111": 0, "110": 1, "121": 5, "120": 2, "131": 7, "130": 3, "141": 9, "140": 4, "151": 13, "150": 5, "161": 15, "160": 6, "171": 17, "170": 7, "181": 19, "180": 8, "191": 21, "190": 9, "201": 2, "200": 10, "211": 4, "210": 11, "221": 18, "220": 12, "231": 20, "230": 13, "241": 11, "240": 14, "251": 3, "250": 15, "261": 6, "260": 16, "271": 8, "270": 17, "281": 12, "280": 18, "291": 14, "290": 19, "301": 16, "300": 20, "311": 10, "310": 21, "321": 22, "320": 22, "331": 25, "330": 23, "341": 24, "340": 24, "351": 23, "350": 25};

        let codiceControllo = 0;
        for (let i = 0; i < 15; i++) {
            codiceControllo += matriceCodiceControllo[caratteri.indexOf(codiceFiscale[i]).toString() + ((i + 1) % 2).toString()];
        }
        return alfabeto[codiceControllo % 26];
    }

    function validaCodiceFiscalePrivato(valore) {
        valore = valore.trim().toUpperCase();
        let codiceCalcolato;
        let indiceCodiceLuogoNascita;
        for (const omocodia1 of [false, true]) {
            for (const omocodia2 of [false, true]) {
                for (const omocodia3 of [false, true]) {
                    for (const omocodia4 of [false, true]) {
                        for (const omocodia5 of [false, true]) {
                            for (const omocodia6 of [false, true]) {
                                for (const omocodia7 of [false, true]) {
                                    codiceCalcolato = true;
                                    indiceCodiceLuogoNascita = 0;
                                    while (codiceCalcolato) {
                                        codiceCalcolato = calcolaPrivatoCodiceFiscale([omocodia1, omocodia2, omocodia3, omocodia4, omocodia5, omocodia6, omocodia7], indiceCodiceLuogoNascita);
                                        if (codiceCalcolato === valore) {
                                            return true;
                                        }
                                        indiceCodiceLuogoNascita++;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return false;
    }

    function validaCodiceFiscalePartitaIva(valore) {
        valore = valore.trim().toUpperCase();
        let codiceControllo;

        // Codice fiscale, inclusa la sostituzione delle cifre con lettere per casi di omocodia
        if (valore.match(/^[A-Z]{6}[A-Z0-9]{2}[A-Z][A-Z0-9]{2}[A-Z][A-Z0-9]{3}[A-Z]$/)) {
            try {
                codiceControllo = codiceControlloCodiceFiscale(valore.substr(0, 15));
            } catch (error) {
                return false;
            }
            return codiceControllo === valore.at(15);
        }

        // Partita iva
        if (valore.match(/^[0-9]{11}$/)) {
            try {
                let somma = 0;
                let cifra;
                for (let i = 0; i < 10; i++) {
                    cifra = parseInt(valore[i]);
                    if (i % 2) {
                        cifra *= 2;
                        if (cifra >= 10) cifra -= 9;
                    }
                    somma += cifra;
                }
                codiceControllo = (10 - (somma % 10)) % 10;
            } catch (error) {
                return false;
            }
            return codiceControllo === parseInt(valore.at(10));
        }

        // Formato non riconosciuto
        return false;
    }

    function validateFields() {
        // Come prima cosa rimuovo required e gli errori custom da tutti
        datiFatturazioneModal.querySelectorAll('[required]').forEach(el => {
            el.removeAttribute("required");
        });
        datiFatturazioneModal.querySelectorAll('[data-has-custom-error]').forEach(el => {
            el.removeAttribute("data-has-custom-error");
            el.setCustomValidity("");
        });

        const fieldsData = {};

        const doveRisiedi = datiFatturazioneModal.querySelector('[name="dove-risiedi"]:checked')?.value;
        setRequired('dove-risiedi');
        fieldsData["dove-risiedi"] = doveRisiedi;

        if (doveRisiedi === "italia") {
            const tipoFattura = datiFatturazioneModal.querySelector('[name="tipo-fattura"]:checked')?.value;
            setRequired('tipo-fattura');
            fieldsData["tipo-fattura"] = tipoFattura;

            if (tipoFattura === "privato") {
                const cognome = datiFatturazioneModal.querySelector('[name="privato--cognome"]').value;
                setRequired('privato--cognome');
                fieldsData["privato--cognome"] = cognome;

                const nome = datiFatturazioneModal.querySelector('[name="privato--nome"]').value;
                setRequired('privato--nome');
                fieldsData["privato--nome"] = nome;

                const dataNascita = datiFatturazioneModal.querySelector('[name="privato--data-nascita"]').value;
                setRequired('privato--data-nascita');
                fieldsData["privato--data-nascita"] = dataNascita;

                const genere = datiFatturazioneModal.querySelector('[name="privato--genere"]:checked')?.value;
                setRequired('privato--genere');
                fieldsData["privato--genere"] = genere;

                const paeseNascita = datiFatturazioneModal.querySelector('[name="privato--paese-nascita"]:checked')?.value;
                setRequired('privato--paese-nascita');
                fieldsData["privato--paese-nascita"] = paeseNascita;

                if (paeseNascita === "italia") {
                    const luogoNascita = datiFatturazioneModal.querySelector('[name="privato--luogo-nascita"]').value;
                    setRequired('privato--luogo-nascita');
                    if (luogoNascita) {
                        setCustomValidityMsg('privato--luogo-nascita', datiFatturazioneCodiciItalia.hasOwnProperty(luogoNascita.trim().toUpperCase()), 'luogo-nascita-non-valido');
                    }
                    fieldsData["privato--luogo-nascita"] = luogoNascita;
                }

                if (paeseNascita === "estero") {
                    const nazioneNascita = datiFatturazioneModal.querySelector('[name="privato--nazione-nascita"]').value;
                    setRequired('privato--nazione-nascita');
                    if (nazioneNascita) {
                        setCustomValidityMsg('privato--nazione-nascita', datiFatturazioneCodiciEstero.hasOwnProperty(nazioneNascita.trim().toUpperCase()), 'nazione-nascita-non-valida');
                    }
                    fieldsData["privato--nazione-nascita"] = nazioneNascita;
                }

                const codiceFiscalePrivato = datiFatturazioneModal.querySelector('[name="privato--codice-fiscale"]').value;
                setRequired('privato--codice-fiscale');
                if (codiceFiscalePrivato) {
                    setCustomValidityMsg('privato--codice-fiscale', validaCodiceFiscalePrivato(codiceFiscalePrivato), 'codice-fiscale-non-valido');
                }
                fieldsData["privato--codice-fiscale"] = codiceFiscalePrivato;
            }
            
            if (tipoFattura === "azienda") {
                const ragioneSociale = datiFatturazioneModal.querySelector('[name="azienda--ragione-sociale"]').value;
                setRequired('azienda--ragione-sociale');
                fieldsData["azienda--ragione-sociale"] = ragioneSociale;

                const partitaIva = datiFatturazioneModal.querySelector('[name="azienda--partita-iva"]').value;
                setRequired('azienda--partita-iva');
                if (partitaIva) {
                    setCustomValidityMsg('azienda--partita-iva', validaCodiceFiscalePartitaIva(partitaIva), 'partita-iva-non-valida');
                }
                fieldsData["azienda--partita-iva"] = partitaIva;

                const codiceFiscaleAzienda = datiFatturazioneModal.querySelector('[name="azienda--codice-fiscale"]').value;
                setRequired('azienda--codice-fiscale');
                if (codiceFiscaleAzienda) {
                    setCustomValidityMsg('azienda--codice-fiscale', validaCodiceFiscalePartitaIva(codiceFiscaleAzienda), 'codice-fiscale-non-valido');
                }
                fieldsData["azienda--codice-fiscale"] = codiceFiscaleAzienda;

                const codiceSdi = datiFatturazioneModal.querySelector('[name="azienda--codice-sdi"]').value;
                if (codiceSdi) {
                    setCustomValidityMsg('azienda--codice-sdi', codiceSdi.trim().length === 7, 'codice-sdi-non-valido');
                }
                fieldsData["azienda--codice-sdi"] = codiceSdi;

                const pec = datiFatturazioneModal.querySelector('[name="azienda--pec"]').value;
                fieldsData["azienda--pec"] = pec;

                setCustomValidityMsg('azienda--codice-sdi', codiceSdi || pec, 'sdi-pec-almeno-uno');
            }
        }

        return fieldsData;
    }

    function setRequired(name) {
        datiFatturazioneModal.querySelectorAll(`[name="${name}"]`).forEach(el => {
            el.setAttribute("required", true);
        });
    }

    function setCustomValidityMsg(name, valid, dataAttr) {
        datiFatturazioneModal.querySelectorAll(`[name="${name}"]`).forEach(el => {
            if (el.hasAttribute("data-has-custom-error")) return;
            if (valid) {
                el.setCustomValidity("");
            } else {
                el.setAttribute('data-has-custom-error', true);
                el.setCustomValidity(el.getAttribute(`data-custom-error-${dataAttr}`));
            }
        });
    }

    function autocompleteField(id, opzioni) {
        const field = datiFatturazioneModal.querySelector(`#dati-fatturazione--${id}--field`);
        const list = datiFatturazioneModal.querySelector(`#dati-fatturazione--${id}--list`);
        opzioni.sort();
        for (const opzione of opzioni) {
            const opt = document.createElement("option");
            opt.value = opzione;
            list.append(opt);
        }
    }

    autocompleteField('privato--luogo-nascita', Object.keys(datiFatturazioneCodiciItalia));
    autocompleteField('privato--nazione-nascita', Object.keys(datiFatturazioneCodiciEstero));
});
